import { render, staticRenderFns } from "./seckill-tips.vue?vue&type=template&id=6b0bbac3&scoped=true&"
import script from "./seckill-tips.vue?vue&type=script&lang=js&"
export * from "./seckill-tips.vue?vue&type=script&lang=js&"
import style0 from "./seckill-tips.vue?vue&type=style&index=0&id=6b0bbac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bbac3",
  null
  
)

export default component.exports